import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// material-ui
import { makeStyles, useTheme } from "@material-ui/styles";
import { Box, Drawer, useMediaQuery } from "@material-ui/core";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";
import { BrowserView, MobileView } from "react-device-detect";

// project imports
import MenuList from "./MenuList";
import LogoSection from "../LogoSection";
import MenuCard from "./MenuCard";
import { drawerWidth } from "./../../../store/constant";

//Company Logo
import nbLogo from "../../../assets/images/comapnyLogo/Gmark.png";
import SmarterSpider from "../../../assets/images/comapnyLogo/smartSpider.png";
import EcomepPCE from "../../../assets/images/comapnyLogo/ecomep.png";
import WhiteLogo from "../../../assets/images/comapnyLogo/white.png";

// style constant
const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 10,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    // background: theme.palette.background.default,
    background: "rgb(237, 231, 246,0.9)",
    borderRight: "1px solid #5a2198",
    color: "#000",
    // borderRight: "none",
    [theme.breakpoints.up("md")]: {
      top: "51px",
    },
  },
  ScrollHeight: {
    height: "calc(100vh - 88px)",
    paddingLeft: "0px",
    paddingRight: "0px",
    margin: "0px",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
  },
  boxContainer: {
    display: "flex",
    padding: "0px",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

//-----------------------|| SIDEBAR DRAWER ||-----------------------//

const Sidebar = ({ drawerOpen, drawerToggle, window, type }) => {
  const account = useSelector((state) => state.account);
  const classes = useStyles();
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));

  // 🧠 STEP 1: Define all brand configurations here
  const brandConfigs = [
    {
      name: "SmarterSpider",
      domains: ["dashboard.smarterspider.com"],
      logo: SmarterSpider,
      loginOnly: true,
      style: {
        width: "100%",
        height: 40,
        objectFit: "contain",
        padding: "10px 0",
      },
    },
    {
      name: "EcomepPCE",
      domains: ["63gma.pointcloudengg.com"],
      logo: EcomepPCE,
      loginOnly: true,
      style: {
        width: "100%",
        height: 40,
        objectFit: "contain",
        padding: "10px 0",
      },
    },
    {
      name: "SkillNet",
      domains: ["demo.skillnetlearning.com"],
      logo: WhiteLogo,
      loginOnly: true,
      style: {
        width: "100%",
        height: 40,
        objectFit: "contain",
        padding: "10px 0",
      },
    },
  ];

// 🧠 STEP 2: Setup state for logo
const [logoSource, setLogoSource] = useState(nbLogo);
const [logoStyle, setLogoStyle] = useState({
  width: "100%",
  height: 35,
});

// 🧠 STEP 3: Detect hostname after mount
useEffect(() => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    for (const brand of brandConfigs) {
      const isMatchedDomain = brand.domains.includes(hostname);
      const isLoginPage = pathname === "/login"; // optional condition

      // if you want the logo to persist across all pages, remove isLoginPage check
      if (isMatchedDomain /* && isLoginPage */) {
        setLogoSource(brand.logo);
        setLogoStyle(brand.style);
        return;
      }
    }
  }
}, []);


  const drawer = (
    <React.Fragment>
      {/* <div className={classes.boxContainer}>
        {logoSource && (
          <img
            src={logoSource}
            style={logoStyle}
            rel="preload"
            fetchpriority="high"
            alt="Company Logo"
          />
        )}
      </div> */}

      <BrowserView>
        <PerfectScrollbar component="div" className={classes.ScrollHeight}>
          <MenuList type={type} />
        </PerfectScrollbar>
      </BrowserView>

      <MobileView>
        <Box sx={{ px: 0 }}>
          <MenuList type={type} />
        </Box>
      </MobileView>
    </React.Fragment>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Drawer
        transitionDuration={0}
        container={container}
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}

        {/* {logoSource && (
          <img
            src={logoSource}
            style={logoStyle}
            rel="preload"
            fetchpriority="high"
            alt="NBSense"
          />
        )} */}
      </Drawer>
    </nav>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;
